import React from 'react';
import {
  Document,
  Page,
  View,
  Text,
  Font,
  StyleSheet,
  Image
} from '@react-pdf/renderer';
import moment from 'moment';

import InterRegular from '../../../assets/fonts/Inter-Regular.ttf';
import InterBold from '../../../assets/fonts/Inter-Bold.ttf';

Font.register({
  family: 'Inter',
  fonts: [
    { src: InterRegular },
    { src: InterBold, fontWeight: 'bold' },
  ],
});

const styles = StyleSheet.create({
  page: {
    padding: 5,
    fontFamily: 'Inter',
    fontSize: 10,
    color: '#000000',
  },
  card: {
    border: '1px solid #000',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%'
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid #000',
    padding: 12,
  },
  logo: {
    height: 20,
    width: 'auto',
  },
  companyInfo: {
    fontSize: 8,
    textAlign: 'right',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  section: {
    borderBottom: '1px solid #000',
    padding: 12,
  },
  bold: {
    fontFamily: 'Inter',
    fontWeight: 'bold',
  },
  row: {
    marginTop: 8,
    flexDirection: 'row',
    alignItems: 'center',
  },
  note: {
    padding: 12,
  }
});

const ShippingLabelPDF = ({
  tenant,
  hospital,
  deliveryAddress,
  surgeon,
  procedure,
  procedureOption,
  activeCase,
  note,
}) => {
  return (
    <Document>
      <Page
        size={{ width: 283, height: 425 }}  // 10cm x 15cm
        style={styles.page}
      >
        <View style={styles.card}>
          <View style={styles.header}>
            <View>
              {tenant?.documentLogo?.downloadUrl && (
                <Image src={tenant.documentLogo.downloadUrl} style={styles.logo} />
              )}
            </View>
            <View style={styles.companyInfo}>
              <Text style={{ textAlign: 'right' }}>{tenant?.businessName || ''}</Text>
              <Text style={{ textAlign: 'right' }}>{tenant?.address1 || ''}</Text>
              <Text style={{ textAlign: 'right' }}>{tenant?.city || ''}, {tenant?.state || ''}, {tenant?.postCode || ''}</Text>
              <Text style={{ textAlign: 'right' }}>{tenant?.phone || ''}</Text>
            </View>
          </View>

          <View style={styles.section}>
            <Text style={{ marginTop: 4, fontSize: 8 }}>Shipping To:</Text>
            <Text style={{ ...styles.bold, marginTop: 4, fontSize: 11 }}>{hospital?.name}</Text>
            <Text style={{ marginTop: 2, fontSize: 8 }}>{deliveryAddress?.street}</Text>
            <Text style={{ marginTop: 2, fontSize: 8 }}>{`${deliveryAddress?.city}, ${deliveryAddress?.state} ${deliveryAddress?.postCode || ''}`}</Text>
          </View>

          <View style={styles.section}>
            <View style={styles.row}>
              <Text style={{ width: 70, fontSize: 8 }}>Surgeon: </Text>
              <Text style={styles.bold}>{`${surgeon?.title} ${surgeon?.firstName} ${surgeon?.lastName}`}</Text>
            </View>
            <View style={styles.row}>
              <Text style={{ width: 70, fontSize: 8 }}>Surgery Date: </Text>
              <Text style={styles.bold}>
                {activeCase?.date ? moment(activeCase.date).format('Do MMMM YYYY') : ''}
              </Text>
            </View>
            <View style={styles.row}>
              <Text style={{ width: 70, fontSize: 8 }}>Procedure: </Text>
              <Text style={styles.bold}>
                {`${procedure?.name}${procedureOption?.name ? `, ${procedureOption?.name}` : ''}`}
              </Text>
            </View>
            <View style={styles.row}>
              <Text style={{ width: 70, fontSize: 8 }}>Patient ID: </Text>
              <Text style={styles.bold}>{activeCase?.patientReference}</Text>
            </View>
            <View style={{ ...styles.row, marginBottom: 8 }}>
              <Text style={{ width: 70, fontSize: 8 }}>Case ID: </Text>
              <Text style={styles.bold}>{activeCase?.id}</Text>
            </View>
          </View>

          <View style={styles.note}>
            <Text style={{ fontSize: 8, marginTop: 4 }}>Shipping Note:</Text>
            <Text style={{ ...styles.bold, marginTop: 4, fontSize: 11 }}>{note}</Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default ShippingLabelPDF;
